import React from 'react'

import { Body2, Body3, Box, Color, Space } from '@gousto-internal/citrus-react'

type ReviewCardProps = {
  quote: string
  reviewer: string
}

export function ReviewsCard({ quote, reviewer }: ReviewCardProps) {
  return (
    <Box
      bg={Color.White}
      paddingH={5}
      paddingV={5}
      paddingBottom={0}
      boxShadow="0 4px 6px -2px rgba(33, 41, 48, 0.03)"
      style={{ borderRadius: '8px' }}
      width="325px"
      height="144px"
    >
      <Body2 size={4} color={Color.ColdGrey_800}>
        {quote}
      </Body2>
      <Space size={3} />
      <Body3 size={2} color={Color.ColdGrey_500}>
        {reviewer}
      </Body3>
    </Box>
  )
}
